/** The references object of all modules needed for components initialization */
var references = {
    'clp' : require('_core_ext/pages/clp'),
    'brands': require('_core_ext/pages/search/brands'),
    'refinements' : require('_core_ext/pages/search/refinements'),
};

module.exports = {
    'references' : references
};
